import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useLanguage } from '../../../contexts/LanguageContext';
import useTrainingDocumentData from './hook/useTrainingDocumentData';
import TrainingDocumentTable from './components/TrainingDocumentTable';
import TrainingDocumentAddDialog from './components/TrainingDocumentAddDialog';
import TrainingDocumentEditDialog from './components/TrainingDocumentEditDialog';
import TrainingDocumentPreviewDialog from './components/TrainingDocumentPreviewDialog';
import { useLmsPermission } from '../hooks/useLmsPermission';
import { LMS } from '../../../constants/permissionCodes';

const TrainingDocumentPage = ({ readOnly = false }) => {
    const { th } = useLanguage();
    const { can } = useLmsPermission();
    const canUpdate = can(LMS.TRAINING_UPDATE);
    const canDelete = can(LMS.TRAINING_DELETE);
    const {
        formik,
        editFormik,
        vehicleOptions,
        trainingOptions,
        documents,
        filters,
        selectedDocument,
        addDialogVisible,
        previewDocument,
        previewUrl,
        isFetchingVehicles,
        isFetchingTrainings,
        isFetchingDocuments,
        isDeleting,
        isFetchingPreview,
        selectVehicle,
        selectFiles,
        onFilter,
        openAddDialog,
        closeAddDialog,
        openEditDialog,
        closeEditDialog,
        openPreviewDialog,
        closePreviewDialog,
        downloadTrainingDocument,
        removeDocument
    } = useTrainingDocumentData();

    return (
        <div className="card">
            {!readOnly && <ConfirmDialog />}

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th(readOnly ? 'lmsTrainingDocument.libraryTitle' : 'lmsTrainingDocument.title')}</h1>
                {!readOnly && can(LMS.TRAINING_CREATE) && <Button label={th('lmsTrainingDocument.addButton')} icon="pi pi-plus" onClick={openAddDialog} />}
            </div>

            <TrainingDocumentTable documents={documents} loading={isFetchingDocuments} onEdit={canUpdate || canDelete ? openEditDialog : undefined} onPreview={openPreviewDialog} readOnly={readOnly} filters={filters} onFilter={onFilter} />

            {readOnly && <TrainingDocumentPreviewDialog visible={Boolean(previewDocument)} onHide={closePreviewDialog} document={previewDocument} previewUrl={previewUrl} loading={isFetchingPreview} />}

            {!readOnly && (
                <>
                    <TrainingDocumentAddDialog
                        visible={addDialogVisible}
                        onHide={closeAddDialog}
                        formik={formik}
                        vehicleOptions={vehicleOptions}
                        trainingOptions={trainingOptions}
                        loadingVehicles={isFetchingVehicles}
                        loadingTrainings={isFetchingTrainings}
                        loading={formik.isSubmitting}
                        onVehicleChange={selectVehicle}
                        onFilesChange={selectFiles}
                    />
                    <TrainingDocumentEditDialog
                        visible={Boolean(selectedDocument)}
                        onHide={closeEditDialog}
                        formik={editFormik}
                        loading={editFormik.isSubmitting}
                        deleting={isDeleting}
                        document={selectedDocument}
                        onDelete={canDelete ? removeDocument : undefined}
                        readOnly={!canUpdate}
                        onDownloadDocument={downloadTrainingDocument}
                    />
                </>
            )}
        </div>
    );
};

export default TrainingDocumentPage;
